import React from 'react';
import { FaCaretRight } from 'react-icons/fa';
import { moeda } from '../../../funcoes';
import { Spacer } from '../../../Spacer';

export function LineData({ label, description, price, quantity }) {
  return (
    <div
      style={{
        marginTop: 8,
        marginRight: 8,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center' }}>
        <FaCaretRight color="#04346D" />
        <b>{label}:</b>
        <Spacer x={4} />
        {description}
      </span>
      <Spacer x={12} />
      <b>
        {Boolean(quantity && price) && `${quantity} x `}
        {Boolean(price) && moeda(price)}
      </b>
    </div>
  );
}
